import { ChevronRight } from '@mui/icons-material';
import { Avatar, lighten, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, useTheme, } from '@mui/material';
import * as Preact from 'preact';
import { reorderDimensionsDisplayText } from './utils/reorderDimensionsDisplayText';
import { getDisplayName } from './utils/translationHelpers';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var t = useTranslations().t;
    var theme = useTheme();
    return (Preact.h(List, null, p.partsMetadata.map(function (metadata) { return (Preact.h(ListItem, { sx: {
            padding: '0px',
            marginBottom: '8px',
            borderRadius: '4px',
            overflow: 'hidden',
        } },
        Preact.h(ListItemButton, { disabled: metadata.optionsCount ? metadata.optionsCount < 2 : false, onClick: function () { return p.onPartClick(metadata.id); }, "data-testid": "parts-list-button", sx: {
                '&:hover': {
                    backgroundColor: lighten(theme.palette.primary.main, 0.9),
                },
                '&.Mui-disabled': {
                    opacity: '1',
                },
            } },
            metadata.thumbnail && (Preact.h(ListItemAvatar, null,
                Preact.h(Avatar, { src: metadata.thumbnail, variant: "square" }))),
            Preact.h(ListItemText, { primary: getDisplayName('furniture.option.', metadata.label, t), primaryTypographyProps: { variant: 'body2' }, secondary: p.reorderDimensions && metadata.subtitle
                    ? reorderDimensionsDisplayText(metadata.subtitle)
                    : metadata.subtitle === 'furniture.option.none'
                        ? t(metadata.subtitle)
                        : metadata.subtitle, secondaryTypographyProps: {
                    variant: 'body2',
                    color: 'rgba(0, 0, 0, 0.54)',
                } }),
            (metadata.optionsCount ? metadata.optionsCount >= 2 : true) && (Preact.h(ListItemIcon, { sx: { display: 'flex', justifyContent: 'flex-end' } },
                Preact.h(ChevronRight, { color: "primary" })))))); })));
};
Component.displayName = 'PartsList';
